import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import "./FinalInvoice.css";
import html2pdf from "html2pdf.js";
import { LoadingSpinner } from "../../components/LoadingSpinner/LoadingSpinner";
import { useComponentLoading } from "../../utils/useComponentLoading";

const FinalInvoice = ({ 
    invoiceNumber: propsInvoiceNumber, 
    finalHtml: propsFinalHtml,
    isLoading: propsIsLoading,
    loadingMessage: propsLoadingMessage,
    loadingProgress: propsLoadingProgress 
}) => {
    const location = useLocation();
    const { withLoading, isLoading, getMessage, getProgress } = useComponentLoading();

    // Use props if provided, otherwise fallback to location.state
    const invoiceNumber = propsInvoiceNumber || (location.state && location.state.invoiceNumber);
    const finalHtml = propsFinalHtml || (location.state && location.state.finalHtml);

    if (!invoiceNumber || !finalHtml) {
        return <div>Error: Missing invoice data</div>;
    }

    const handleDownloadPDF = async () => {
        try {
            await withLoading('downloadPDF', async (onProgress) => {
                onProgress(20, 'Preparing PDF content...');

                const updatedHtml = document.getElementById("invoice-content").innerHTML;

                // Create a temporary div element
                const tempDiv = document.createElement("div");
                tempDiv.innerHTML = updatedHtml;
                document.body.appendChild(tempDiv);

                onProgress(40, 'Generating PDF...');

                const opt = {
                    margin: [15, 0, 15, 0], // Top, right, bottom, left margins
                    filename: `Invoice_${invoiceNumber}.pdf`,
                    image: { type: 'jpeg', quality: 1 },
                    html2canvas: { scale: 3, useCORS: true },
                    jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' }
                };

                onProgress(60, 'Converting to PDF format...');

                await html2pdf().from(tempDiv).set(opt).save();
                
                onProgress(90, 'Finalizing download...');
                
                // Remove the temporary div element after the PDF is generated
                document.body.removeChild(tempDiv);
                
                onProgress(100, 'Download complete!');
            });
        } catch (error) {
            console.error('Error generating PDF:', error);
        }
    };

    const showLoading = propsIsLoading || isLoading('downloadPDF');
    const loadingMessage = isLoading('downloadPDF') ? getMessage('downloadPDF') : propsLoadingMessage;
    const loadingProgress = isLoading('downloadPDF') ? getProgress('downloadPDF') : propsLoadingProgress;

    if (showLoading) {
        return (
            <div className="loading-container">
                <LoadingSpinner 
                    size="large"
                    message={loadingMessage || "Loading invoice..."}
                    progress={loadingProgress}
                    showProgress={true}
                />
            </div>
        );
    }

    return (
        <div className="final-invoice-container">
            <div id="invoice-content" className="invoice-html" contentEditable dangerouslySetInnerHTML={{ __html: finalHtml }}></div>
            <div className="download-pdf-container">
                <button style={{width: '100%'}}
                    className="custom-button" 
                    onClick={handleDownloadPDF}
                    disabled={isLoading('downloadPDF')}
                >
                    {isLoading('downloadPDF') ? 'Generating PDF...' : 'Download PDF'}
                </button>
            </div>
        </div>
    );
};

export default FinalInvoice;